import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/app/Common";
import AppLayout from "@/components/app/AppLayout";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import TaskUpdate from "@/pages/TaskUpdate";
import DecisionReview from "@/pages/DecisionReview";
import AllocationReview from "@/pages/AllocationReview";
import Growth from "@/pages/Growth";
import Dashboard from "@/pages/Dashboard";
import Entities from "@/pages/Entities";
import Compliance from "@/pages/Compliance";
import Revival from "@/pages/Revival";
import Tax from "@/pages/Tax";
import Receipts from "@/pages/Receipts";
import Vault from "@/pages/Vault";
import CalendarPage from "@/pages/CalendarPage";
import Assistant from "@/pages/Assistant";
import Portfolio from "@/pages/Portfolio";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import ChiefOfStaff from "@/pages/ChiefOfStaff";
import Deals from "@/pages/Deals";
import Decisions from "@/pages/Decisions";
import WaitingOn from "@/pages/WaitingOn";
import RegulatoryWatch from "@/pages/RegulatoryWatch";
import ResearchLab from "@/pages/ResearchLab";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/u/:token" element={<TaskUpdate />} />
      <Route path="/d/:token" element={<DecisionReview />} />
      <Route path="/r/:token" element={<AllocationReview />} />
      <Route path="/register" element={<AuthPage mode="register" />} />
      <Route path="/payment/success" element={<Protected><PaymentResult success /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentResult /></Protected>} />
      <Route path="/app" element={<Protected><AppLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="portfolio" element={<Portfolio />} />
        <Route path="entities" element={<Entities />} />
        <Route path="compliance" element={<Compliance />} />
        <Route path="revival" element={<Revival />} />
        <Route path="tax" element={<Tax />} />
        <Route path="receipts" element={<Receipts />} />
        <Route path="vault" element={<Vault />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="assistant" element={<Assistant />} />
        <Route path="chief-of-staff" element={<ChiefOfStaff />} />
        <Route path="deals" element={<Deals />} />
        <Route path="decisions" element={<Decisions />} />
        <Route path="waiting" element={<WaitingOn />} />
        <Route path="regulatory" element={<RegulatoryWatch />} />
        <Route path="research-lab" element={<ResearchLab />} />
        <Route path="growth" element={<Growth />} />
        <Route path="billing" element={<Billing />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
